import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import CargandoSpinner from "../../Utils/CargandoSpinner";
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import { useAuth } from '../../../Auth/AuthContext';
import { ConvertErrors422ToString } from '../../Utils/ConvertErrors422ToString';

export default function Ingresos() {
    const { token, user } = useAuth();
    const [cargando, setCargando] = useState(false);
    const [entidades, setEntidades] = useState([]);
    const [swalProps, setSwalProps] = useState({})
    const [tiposAyuda, setTiposAyuda] = useState([]);
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };
    async function ConsultarAyudasXEntidades(entidadId) {
        const url = '/bodega/consultarayudasxentidad';
        const obj = { entidadId: entidadId };
        await apiService.post(url, obj, token)
        .then((response) => {
            const result = response.data;
            if(result.ayudas){
                setTiposAyuda(result.ayudas);
            } else {
                setTiposAyuda([]);
            }
        })
        .catch((error) => {
            console.error('Error fetching ayudas:', error);
            setTiposAyuda([]);
        });
    }
    const InicializarFormulario = React.useCallback(async () => {
        const url = '/bodega/inicializarformularioingresobodega';
        const obj = {};
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if(result.entidades){
                setEntidades(result.entidades);
                setValue('usrid', user);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }, [token]);
    useEffect(() => {
        InicializarFormulario();
    }, [InicializarFormulario]);
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/bodega/registraringresobodega';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Registrar', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar', JSON.stringify(ConvertErrors422ToString(error.response.data.errors)));
            }else if(error.status === 409){
                Mensaje('Registrar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Ingresos Bodega AHE"
                idCabezaFamilia="1"
                url="/bodega/ahe"
                nombreurl="AHE"
                nombreform="Ingresos Bodega AHE"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Ingresos Bodega AHE</h3>
                                </div>
                                <div className="card-body">
                                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                        <input hidden {...register('usrid')}/>
                                        <div className="form-group">
                                            <label htmlFor="entidad">Entidad <span style={{color: 'red'}}>*</span></label>
                                            <select
                                                id="entidad"
                                                className={`form-control ${errors.entidad ? 'is-invalid' : ''}`}
                                                {...register("entidad", { required: "La entidad es obligatoria" })}
                                                onChange={(e) => {
                                                    const selectedValue = e.target.value;
                                                    ConsultarAyudasXEntidades(selectedValue);
                                                    setValue("idayuda", "");
                                                    setValue("entidad", selectedValue);
                                                    const today = new Date();
                                                    const yyyy = today.getFullYear();
                                                    const mm = String(today.getMonth() + 1).padStart(2, '0');
                                                    const dd = String(today.getDate()).padStart(2, '0');
                                                    setValue("fecha_ingreso", `${yyyy}-${mm}-${dd}`);
                                                }}
                                            >
                                                <option value="">Seleccione una entidad</option>
                                                {entidades.map((entidad) => (
                                                    <option key={entidad.id} value={entidad.id}>
                                                        {entidad.ent_entidad}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.entidad && (
                                                <div className="invalid-feedback">{errors.entidad.message}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="idayuda">Tipo de Ayuda <span style={{color: 'red'}}>*</span></label>
                                            <select
                                                id="idayuda"
                                                className={`form-control ${errors.tipo_ayuda ? 'is-invalid' : ''}`}
                                                {...register("idayuda", { required: "El tipo de ayuda es obligatorio" })}
                                            >
                                                <option value="">Seleccione un tipo de ayuda</option>
                                                {tiposAyuda.map((tipo) => (
                                                    <option key={tipo.id} value={tipo.id}>
                                                        {tipo.ayu_ayuda}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.idayuda && (
                                                <div className="invalid-feedback">{errors.idayuda.message}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="cantidad">Cantidad <span style={{color: 'red'}}>*</span></label>
                                            <input
                                                type="number"
                                                id="cantidad"
                                                className={`form-control ${errors.cantidad ? 'is-invalid' : ''}`}
                                                {...register("cantidad", { 
                                                    required: "La cantidad es obligatoria", 
                                                    valueAsNumber: true,
                                                    min: { value: 1, message: "La cantidad debe ser mayor a 0" }
                                                })}
                                            />
                                            {errors.cantidad && (
                                                <div className="invalid-feedback">{errors.cantidad.message}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="valor">Valor <span style={{color: 'red'}}>*</span></label>
                                            <input
                                                type="number"
                                                id="valor"
                                                className={`form-control ${errors.valor ? 'is-invalid' : ''}`}
                                                {...register("valor", { 
                                                    required: "El valor es obligatorio", 
                                                    valueAsNumber: true,
                                                    min: { value: 1, message: "El valor debe ser mayor a 0" }
                                                })}
                                            />
                                            {errors.valor && (
                                                <div className="invalid-feedback">{errors.valor.message}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fecha_ingreso">Fecha de Ingreso <span style={{color: 'red'}}>*</span></label>
                                            <input
                                                type="date"
                                                id="fecha_ingreso"
                                                className={`form-control ${errors.fecha_ingreso ? 'is-invalid' : ''}`}
                                                {...register("fecha_ingreso", { required: "La fecha de ingreso es obligatoria" })}
                                            />
                                            {errors.fecha_ingreso && (
                                                <div className="invalid-feedback">{errors.fecha_ingreso.message}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="observaciones">Observaciones</label>
                                            <textarea
                                                id="observaciones"
                                                className={`form-control ${errors.observaciones ? 'is-invalid' : ''}`}
                                                {...register("observaciones", {
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9\s]*$/,
                                                        message: "Solo se permiten letras y números"
                                                    }
                                                })}
                                            />
                                            {errors.observaciones && (
                                                <div className="invalid-feedback">{errors.observaciones.message}</div>
                                            )}
                                        </div>
                                        <button type="submit" className="btn btn-primary">Guardar</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>  
            </section>
        </div>
    );

}